import Button from '../../../components/button'
import capitalize from 'lodash/capitalize'
import Col from 'react-bootstrap/lib/Col'
import Grid from 'react-bootstrap/lib/Grid'
import Image from 'react-bootstrap/lib/Image'
import OpenGraph from '../../../components/openGraph'
import PropTypes from 'prop-types'
import React, {Component, Fragment} from 'react'
import Row from 'react-bootstrap/lib/Row'
import SearchBar from '../../../components/searchBar'
import SeoTextDropdown from '../../../components/seoTextDropdown'
import {aspectRatio} from '../sharedStyles'
import {colors, media, text} from '../../../styles'
import {connect} from 'react-redux'
import {css} from 'glamor'
import {getEntryById, getSeoPageByUrl} from '../../../redux/actions/contentful'
import {trackImpression} from '../actions/impressions'
import shirt from '../../../images/why_prep_shirt.svg'
import map from '../../../images/why_prep_map.svg'
// import shipping from '../../../images/why_prep_shipping.svg'

const HOMEPAGE_ID = 'jn6F5oWsbQ6IEuGMuIAmy'

const style = {
  featuredHeader: css({
    marginBottom: '20px',
    marginTop: 0,
    textAlign: 'center',
    ...media.xs(text.h5)
  }),
  grid: css({
    maxWidth: '1680px',
    padding: 0,
    ...media.xs({
      '& .row:first-child': {
        marginBottom: '30px'
      }
    })
  }),
  tile: css({
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    '& h1, h2, h5, p': {
      color: colors.white,
      textShadow: '2px 2px 4px rgba(0, 0, 0, .6)',
      textTransform: 'none'
    }
  }),
  hero: css({
    padding: '0 30px',
    top: '50%',
    transform: 'translateY(-50%)',
    '& h1': {
      marginTop: 0,
      width: '100%'
    },
    ...media.md({
      '& h1': {
        width: '77%'
      }
    }),
    ...media.sm({
      '& h1': {
        width: '80%'
      }
    }),
    ...media.xs({
      marginTop: '30px',
      position: 'static !important',
      transform: 'none',
      '& h1': css(text.h3, {
        color: `${colors.defaultText} !important`,
        marginTop: 0,
        textAlign: 'center',
        textShadow: 'none !important',
        width: '100%'
      })
    })
  }),
  heroBG: css({
    backgroundPosition: 'top right',
    ...media.xs(aspectRatio(0.5)),
    ...media.sm(aspectRatio(0.34)),
    ...media.md(aspectRatio(0.3)),
    ...media.lg(aspectRatio(0.25))
  }),
  heroWrapper: css({
    marginBottom: '32px',
    position: 'relative',
    zIndex: 1
  }),
  promo: css({
    alignItems: 'center',
    color: colors.white,
    display: 'flex',
    justifyContent: 'center',
    margin: 0,
    padding: '50px 15%',
    ...media.xs({
      display: 'block',
      padding: '50px 10px',
      '& > div': {
        marginBottom: '20px'
      },
      '& > div:last-child': {
        marginBottom: 0
      }
    }),
    ...media.sm({
      padding: '50px 5%'
    }),
    ...media.md({
      padding: '50px 5%'
    }),
    ...media.lg({
      padding: '50px 15%'
    })
  }),
  promoCol: css({
    flex: '1 auto',
    textTransform: 'uppercase !important',
    whiteSpace: 'nowrap',
    ...media.xs({
      textAlign: 'center'
    })
  }),
  get promoDetails() {
    return css(
      {
        textAlign: 'left',
        '& ul': {
          listStyle: 'none',
          margin: 0,
          padding: 0
        },
        '& li': {
          marginBottom: '10px'
        },
        '& li:last-child': {
          marginBottom: 0
        },
        '& .highlight': {
          color: colors.flamingoOrange
        },
        ...media.mobile(text.h4),
        ...media.desktop(text.h3)
      },
      style.promoCol
    )
  },
  get promoImage() {
    return css(
      {
        textAlign: 'center',
        '& img': {
          width: '100%'
        },
        ...media.xs({
          '& img': {
            width: '80%'
          }
        })
      },
      style.promoCol
    )
  },
  promoLink: css({
    '&:hover': {
      textDecoration: 'none'
    }
  }),
  get promoTitle() {
    return css(
      {
        textAlign: 'right',
        ...media.mobile(text.h3),
        ...media.desktop(text.h2)
      },
      style.promoCol
    )
  },
  store: css(text.body, {
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    margin: '0 0 30px 0',
    '& h2': {
      textTransform: 'uppercase',
      width: '60%',
      ...media.mobile({
        width: '100%'
      })
    },
    '&:before': {
      content: ' ',
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      backgroundImage:
        'linear-gradient(to bottom,rgba(0,0,0,0),rgba(0, 0, 0, 0.36) 75%,#000000)',
      opacity: 0.5
    },
    '& p': {
      marginBottom: '20px'
    },
    '& > div': {
      bottom: 0,
      left: 0,
      right: 0,
      padding: '30px'
    },
    '& .btn': {
      padding: '0 20px',
      width: 'auto'
    },
    ...media.xs({
      margin: '0 20px 20px',
      textAlign: 'center',
      '& .btn': {
        color: colors.white,
        fontWeight: 700,
        textTransform: 'uppercase',
        textDecoration: 'underline'
      },
      ...aspectRatio(1.1)
    }),
    ...media.sm({
      margin: '0 0 30px 0',
      ...aspectRatio(1.1)
    }),
    ...media.md(aspectRatio(0.78)),
    ...media.lg(aspectRatio(0.68))
  }),
  shopSetup: css(text.body, {
    backgroundRepeat: 'no-repeat',
    ...media.xs({
      textAlign: 'center',
      '& h2': text.h4,
      ...aspectRatio(1.05, 'div', {
        top: '20px',
        transform: 'none'
      })
    }),
    ...media.sm({
      backgroundPosition: '150%',
      ...aspectRatio(0.4)
    }),
    ...media.md(aspectRatio(0.3)),
    ...media.lg(aspectRatio(0.3)),
    '& > div': {
      marginLeft: 0,
      marginRight: 0,
      top: '50%',
      transform: 'translateY(-50%)'
    },
    '& h2': {
      textTransform: 'uppercase'
    },
    '& .btn': {
      padding: '0 20px',
      width: 'auto'
    }
  }),
  shopSetupInner: css({
    marginLeft: '35px',
    ...media.xs({
      marginLeft: 0
    }),
    '& p': {
      marginBottom: '20px'
    }
  }),
  whyPrep: css({
    textAlign: 'center',
    '& h4': {
      margin: '30px 0'
    },
    '& > div': {
      paddingBottom: '30px'
    },
    '& p': {
      maxWidth: '300px',
      margin: '-15px auto 0',
      lineHeight: '17px'
    },
    ...media.xs(
      css(text.small, {
        '& h4': text.h5
      })
    )
  }),
  seoText: css({
    borderTop: `1px solid ${colors.gray89}`,
    marginBottom: '-45px'
  }),
  background: ({color, image, size, position}) => {
    const style = {}
    if (color) {
      style.backgroundColor = color
    }
    if (size) {
      style.backgroundSize = size
    }
    if (position) {
      style.backgroundPosition = position
    }
    if (image) {
      style.backgroundImage = `url("${image.fields.file.url}")`
    }

    return css(style)
  }
}

const Store = ({fields, breakpoint}) => (
  <Col xs={12} sm={6}>
    <div
      {...css(style.tile, style.store, {
        textAlign: fields.align || 'left',
        backgroundImage: `url(${fields.background.fields.file.url})`,
        [`margin${capitalize(fields.align || 'left')}`]: '20px'
      })}>
      <div>
        <h2
          {...css(
            fields.align === 'right'
              ? media.desktop({
                  marginLeft: '40%'
                })
              : undefined
          )}>
          {fields.title}
        </h2>
        <p>{fields.description}</p>
        <Button
          href={fields.url}
          kind={breakpoint === 'xs' ? 'link' : 'outline'}
          size="small">
          {fields.cta}
        </Button>
      </div>
    </div>
  </Col>
)

Store.propTypes = {
  breakpoint: PropTypes.string,
  fields: PropTypes.object
}

class Home extends Component {
  static initialize({dispatch}) {
    return Promise.all([
      dispatch(getEntryById(HOMEPAGE_ID, 5)),
      dispatch(getSeoPageByUrl('/'))
    ])
  }

  componentDidMount() {
    if (!window.__CLIENT_STATE__.impression) {
      trackImpression(this.props.headers.referrer)
    }
  }

  render() {
    const {
      location,
      content: {
        fields: {hero, featuredShops, promo, shopSetup}
      },
      media,
      seoPage
    } = this.props

    return (
      <Fragment>
        <OpenGraph
          head={{
            CanonicalUrl: 'https://www.prepsportswear.com',
            Description: seoPage.fields.seo.fields.description,
            OGDescription: seoPage.fields.seo.fields.description,
            PageTitle: seoPage.fields.seo.fields.pageTitle,
            OGTitle: seoPage.fields.seo.fields.pageTitle,
            OGUrl: 'https://www.prepsportswear.com',
            OGImage:
              'http://www.prepsportswear.com/Content/images/Global/linkpage_shareimage.jpg'
          }}
        />
        <Grid fluid {...style.grid}>
          <Row {...style.heroWrapper}>
            <Col xs={12}>
              <div
                {...css(style.tile, style.heroBG, {
                  backgroundImage: `url(${hero.fields.background.fields.file.url})`
                })}>
                <Row {...style.hero}>
                  <Col xs={12} sm={8} smOffset={2} md={6} mdOffset={1}>
                    <h1 className="heroTitle">{hero.fields.title}</h1>
                    <SearchBar
                      location={location}
                      name="jumbotron"
                      placeholder="Search for schools, colleges, and more…"
                    />
                    <h5 className="hidden-xs">{hero.fields.description}</h5>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
          <Row>
            <h4 {...style.featuredHeader}>Featured Shops</h4>
            {featuredShops.map((s, index) => (
              <Store key={index} breakpoint={media.breakpoint} {...s} />
            ))}
          </Row>
          <Row>
            <Col xs={12}>
              <div
                {...css(
                  style.shopSetup,
                  style.background(shopSetup.fields.background.fields)
                )}>
                <Row>
                  <Col xs={12} sm={6} {...style.shopSetupInner}>
                    <h2>{shopSetup.fields.title}</h2>
                    <p>{shopSetup.fields.description}</p>
                    {shopSetup.fields.ctas.map(({fields}, index) => (
                      <Button
                        key={index}
                        href={fields.url}
                        kind={fields.kind}
                        size={fields.size}>
                        {fields.title}
                      </Button>
                    ))}
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Grid>
        {promo && (
          <Grid fluid {...style.grid}>
            <a href={promo.fields.url} {...style.promoLink}>
              <Row
                className="promo"
                {...css(
                  style.promo,
                  style.background(promo.fields.background.fields)
                )}>
                <Col
                  className="promoTitle"
                  xs={12}
                  sm={4}
                  {...style.promoTitle}>
                  <header>{promo.fields.title}</header>
                </Col>
                <Col
                  className="promoImage"
                  xs={12}
                  sm={4}
                  {...style.promoImage}>
                  <Image src={promo.fields.image.fields.file.url} />
                </Col>
                <Col
                  className="promoDetails"
                  xs={12}
                  sm={4}
                  {...style.promoDetails}>
                  <ul>
                    {promo.fields.details.map((detail, index) => (
                      <li key={`promoDetails-${index}`}>{detail}</li>
                    ))}
                  </ul>
                </Col>
              </Row>
            </a>
          </Grid>
        )}
        <Grid>
          <Row {...style.whyPrep}>
            <h4>Why Choose Prep Sportswear</h4>
            <Col xs={12} sm={6}>
              <img src={shirt} />
              <h4>Customizable</h4>
              <p>
                We offer multiple product, color and design choices to create
                your fan or team gear.
              </p>
            </Col>
            <Col xs={12} sm={6}>
              <img src={map} />
              <h4>Printed in America</h4>
              <p>
                Our products are designed in the US to ensure the highest
                standards of quality.
              </p>
            </Col>
            {/*<Col xs={12} sm={4}>
              <img src={shipping} />
              <h4>Quick Delivery</h4>
              <p>
                We ship your custom-produced products 2 to 3 days after
                ordering.
              </p>
            </Col>*/}
          </Row>
        </Grid>

        <div {...style.seoText}>
          <SeoTextDropdown content={seoPage.fields.seo.fields.content} />
        </div>
      </Fragment>
    )
  }
}

Home.propTypes = {
  content: PropTypes.object,
  headers: PropTypes.object.isRequired,
  location: PropTypes.object,
  media: PropTypes.object,
  seoPage: PropTypes.object
}

Home.displayName = 'Home'
Home.staticEntry = 'home'

const stateToProps = state => {
  const {contentful_entries, headers, media} = state
  return {
    content: contentful_entries.items[HOMEPAGE_ID],
    headers,
    media,
    seoPage: contentful_entries.items[contentful_entries.urls['/']]
  }
}

export default connect(stateToProps)(Home)
